// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__IOgdX","messages":"Chat_messages__2sczB","dateDivider":"Chat_dateDivider__GVS5n"};